import { IconButton, Stack, TableCell, TableRow } from '@mui/material'
import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';


const ReadOnlyRow = ({ row, colWidths, handleEditClick, handleDeleteClick }) => {
    return (
        <TableRow key={'fila_' + row.id} width={colWidths.id} >
            <TableCell key={row.id} width="30">
                {row.id}
            </TableCell>
            <TableCell key={'codbar_' + row.id} width={colWidths.codBar}>
                {row.codBar}
            </TableCell>
            <TableCell key={'producto_' + row.id} width={colWidths.product}>
                {row.product}
            </TableCell>
            <TableCell key={'fecha_' + row.id} align='center' width={colWidths.vencimiento}>
                {row.vencimiento}
            </TableCell>
            <TableCell key={'ubicacion_' + row.id} align='left' width={colWidths.ubicacion}>
                {row.ubicacion}
            </TableCell>
            <TableCell key={'cantidad_' + row.id} align='right' width={colWidths.cantidad}>
                {row.cantidad}
            </TableCell>
            <TableCell key={'costo_' + row.id} align='right' width={colWidths.costo}>
                {parseFloat(row.costo).toFixed(2)}
            </TableCell>
            <TableCell key={'total_' + row.id} align='right' width={colWidths.total}>
                {parseFloat(row.total).toFixed(2)}
            </TableCell>
            <TableCell key={'controles_' + row.id} align='left' width={colWidths.controles}>
                <Stack direction='row' spacing={0}>
                    <IconButton aria-label="edit" onClick={(event) => handleEditClick(event, row)}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="edit" onClick={(event) => handleDeleteClick(event, row)}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default ReadOnlyRow